module.exports = __webpack_public_path__ + "static/media/2.cb0a3a37.svg";